<nz-row nzJustify="space-between" nzAlign="middle">
  <nz-col style="margin-bottom: 10px;">
    <!--  [(ngModel)]="searchText" (ngModelChange)="onSearch()" -->
    <input nz-input placeholder="Search..." [(ngModel)]="searchText" (ngModelChange)="onSearch()" />
  </nz-col>
  <nz-col>
    <button nz-button nzType="primary" (click)="onAdd()">Add</button>
    <!--  (click)="onAdd()" -->
  </nz-col>
</nz-row>

<nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
  <nz-table [nzData]="invoiceList" [nzBordered]="true" [nzSize]="'middle'" [nzShowPagination]="false">
    <thead>
      <tr>
        <th nzWidth="120px">Bill No.</th>
        <th nzWidth="200px">Vendor</th>
        <!-- <th>Category</th> -->
        <th nzWidth="130px">Amount</th>
        <th nzWidth="150px">Issue Date</th>
        <th nzWidth="150px">Due Date</th>
        <th nzWidth="130px">Status</th>
        <!-- <th>Remarks</th> -->
        <!-- <th nzWidth="120px">Files</th> -->
        <th nzWidth="120px">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let invoice of invoiceList">
        <td style="font-weight: 600;"> <a href="javascript:void(0)" (click)="onDetailsOpen(invoice.id)"> <nz-tag
              [nzColor]="'geekblue'" nz-tooltip [nzTooltipTitle]="invoice.invoice_number"> {{
              (invoice.invoice_number.length>10)? (invoice.invoice_number | slice:0:10)+'...':(invoice.invoice_number) |
              uppercase }}</nz-tag> </a> </td>
        <td> <a href="javascript:void(0)" (click)="onVendorDetails(invoice?.vendor_details?.id)"> {{
            invoice?.vendor_details?.name | titlecase }} </a> </td>
        <!-- <td>
           <nz-tag [nzColor]="'purple'" *ngFor="let category of invoice.vendor_details?.categories_serviced"
                     [nzBordered]="false"> {{category}}
           </nz-tag>
        </td> -->
        <td>{{ invoice.amount_paid_usd | currency }}</td>
        <td>{{ invoice.issue_date | date:'mediumDate' }}</td>
        <td>{{ invoice.due_date | date:'mediumDate' }}</td>
        <td>
          <nz-tag [nzColor]="
              invoice.status === 'Paid'
                ? 'green'
                : invoice.status === 'Unpaid'
                ? 'red'
                : 'orange'
            ">
            {{ invoice.status }}
          </nz-tag>
        </td>
        <!-- <td style="cursor: default;">
          <span nz-tooltip [nzTooltipTitle]="invoice.description">
            {{ (invoice.description?.length > 10) ? (invoice.description | slice:0:10) + '...' : invoice.description }}
          </span>
        </td> -->
        <!-- <td>
          <span *ngFor="let file of invoice?.file_details; let i = index">
            <a [href]="getFileDownloadLink(file.file_url)" download target="_blank" nz-tooltip
              [nzTooltipTitle]="getFileName(file.file_url)">{{ (getFileName(file.file_url).length>10)?
              (getFileName(file.file_url) | slice:0:10)+'...':(getFileName(file.file_url)) }}</a>
            <span *ngIf="i < invoice?.file_details.length - 1">, </span>
          </span>
        </td> -->
        <td>
          <button nz-button nzType="default" (click)="onInvoiceEdit(invoice)" nzSize="small"><nz-icon nzType="edit"
              nzTheme="outline" />
          </button>
          <button nz-button nzType="default" nzDanger style="margin-left: 10px;" nzSize="small" nz-popconfirm
            nzPopconfirmTitle="Are you sure delete this invoice?" class="custom-popconfirm"
            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'" [nzPopconfirmTitle]="popconfirmTpl"
            nzPopconfirmPlacement="bottom" (nzOnConfirm)="deleteInvoice(invoice.id)"><nz-icon nzType="delete"
              nzTheme="outline" />
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-spin>

<ng-template #popconfirmTpl let-popconfirm="popconfirm">
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">
      Confirm Deletion
    </span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this item?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
</ng-template>